"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledLottiePlayer = exports.Container = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _HBMediaElement = _interopRequireDefault(require("../../HBMediaElement/HBMediaElement"));
var _utils = require("../../HBBanner/utils");
var _lottieReact = _interopRequireDefault(require("lottie-react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _HBClickable = _interopRequireDefault(require("../../HBClickable/HBClickable"));
var _excluded = ["mediaPath", "imageFit", "layout", "onClick", "withImagePadding", "width", "currentStep", "steps"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function CalloutMediaElement(_ref) {
  var mediaPath = _ref.mediaPath,
    imageFit = _ref.imageFit,
    layout = _ref.layout,
    onClick = _ref.onClick,
    withImagePadding = _ref.withImagePadding,
    _width = _ref.width,
    currentStep = _ref.currentStep,
    steps = _ref.steps,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var width = layout === 'side-by-side' ? _width : '100%';
  var _mediaPath;
  var _onClick;
  if (steps) {
    _mediaPath = steps[currentStep].mediaPath;
    _onClick = steps[currentStep].onImageClick;
  } else {
    _mediaPath = mediaPath;
    _onClick = onClick;
  }
  return /*#__PURE__*/_react["default"].createElement(Container, {
    $objectFit: imageFit,
    $layout: layout,
    $withPadding: withImagePadding,
    onClick: _onClick
  }, (0, _utils.isLottieAnimation)(_mediaPath) ? /*#__PURE__*/_react["default"].createElement(StyledLottiePlayer, {
    animationData: _mediaPath,
    $width: width
  }) : /*#__PURE__*/_react["default"].createElement(_HBMediaElement["default"], (0, _extends2["default"])({
    path: _mediaPath,
    width: width
  }, props)));
}
var _default = exports["default"] = CalloutMediaElement; // -------------------------- Styles -------------------------- //
var Container = exports.Container = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "CalloutMediaElement__Container",
  componentId: "sc-1j8tgyf-0"
})(function (_ref2) {
  var $layout = _ref2.$layout,
    $withPadding = _ref2.$withPadding,
    $objectFit = _ref2.$objectFit;
  return (0, _styledComponents.css)(["display:flex;", " *{display:flex;flex:1;object-fit:", ";max-width:100%;height:100%;}"], $withPadding && (0, _styledComponents.css)(["padding:32px 32px ", ";"], $layout === 'side-by-side' ? '32px 0' : '0 32px'), $objectFit);
});
var StyledLottiePlayer = exports.StyledLottiePlayer = (0, _styledComponents["default"])(_lottieReact["default"]).withConfig({
  displayName: "CalloutMediaElement__StyledLottiePlayer",
  componentId: "sc-1j8tgyf-1"
})(["width:", ";height:auto !important;align-self:center;"], function (_ref3) {
  var $width = _ref3.$width;
  return typeof $width === 'string' ? $width : "".concat($width, "px");
});
//# sourceMappingURL=CalloutMediaElement.js.map